@if (visible()) {
  <aside class="aviso-notificaciones" role="region" aria-label="Activar notificaciones">
    <svg class="ic" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/>
    </svg>
    <p class="texto">
      <strong>¿Te avisamos de los chollos al momento?</strong>
      Activa las notificaciones en este navegador.
    </p>
    <button type="button" class="activar" [disabled]="activando()" (click)="activar()">Activar</button>
    <button type="button" class="cerrar" aria-label="Ahora no" title="Ahora no" (click)="cerrar()">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>
    </button>
  </aside>
}
